export function resolveSpokeItemOffsets(args) {
    const { itemCount, spacing, itemOffsets } = args;
    if (!Array.isArray(itemOffsets) || itemOffsets.length !== itemCount) {
        return Array.from({ length: itemCount }, (_, index) => spacing * index);
    }
    const normalized = itemOffsets.map((offset, index) => (Number.isFinite(offset) ? Math.max(0, offset) : spacing * index));
    // Non-decreasing offsets keep the declared item order along the spoke.
    for (let i = 1; i < normalized.length; i += 1) {
        const previous = normalized[i - 1] ?? 0;
        const current = normalized[i] ?? previous;
        if (current < previous)
            normalized[i] = previous;
    }
    return normalized;
}
